// @flow
import { t } from "../constant/translations";

export const BGN = "BGN";
export const EUR = "EUR";

const conversionRate = {
  BGNEUR: 1 / 1.95583,
  EURBGN: 1.95583,
};

export function convertAmount(
  amount: String,
  fromCurrency: String,
  toCurrency: String
) {
  var amountFloat = parseFloat(amount);
  if (fromCurrency !== toCurrency) {
    amountFloat = amountFloat * conversionRate[fromCurrency + toCurrency];
  }
  return amountFloat;
}

export function convertAmountToDefault(amount: String, fromCurrency: String) {
  return convertAmount(amount, fromCurrency, getAppCurrency());
}

export function amountToCurrency(
  amount: String,
  fromCurrency: String,
  toCurrency: String
) {
  if (!amount) {
    amount = 0;
  }
  const amountConverted = convertAmount(amount, fromCurrency, toCurrency);
  const amountStr = amountConverted.toFixed(2).toLocaleString();

  if (toCurrency === EUR) {
    return `${prettyNumber(amountStr)} ${t(`resources.currency.eur`)}`;
  } else if (toCurrency === BGN) {
    return `${prettyNumber(amountStr)} ${t(`resources.currency.bgn`)}`;
  } else {
    return `${prettyNumber(amountStr)} ${toCurrency}`;
  }
}

export function amountToCurrencyOrEmpty(
  amount: String,
  fromCurrency: String,
  toCurrency: String
) {
  if (!amount) {
    return null;
  }
  return amountToCurrency(amount, fromCurrency, toCurrency);
}

export function amountToCurrencyDefault(amount: String, fromCurrency: String) {
  if (!amount) {
    return null;
  }
  return amountToCurrency(amount, fromCurrency, getAppCurrency());
}

export function dualCurrency(amount: String) {
  const amountBgn = amountToCurrency(amount, getAppCurrency(), BGN);
  const amountEur = amountToCurrency(amount, getAppCurrency(), EUR);

  return `${amountBgn} / ${amountEur}`;
}

export function prettyNumber(amountStr: String) {
  let stringLeft = amountStr.toString();
  let slices = [];
  let separatorIdx = 0;
  let prefix = "";

  if (stringLeft.startsWith("-")) {
    prefix = "-";
    stringLeft = stringLeft.slice(1);
  }

  while (separatorIdx < stringLeft.length) {
    const char = stringLeft[separatorIdx];
    if (char === " " || char === ".") {
      break;
    }
    separatorIdx++;
  }

  while (separatorIdx > 2) {
    const nextSep = separatorIdx - 3;
    slices.unshift(stringLeft.slice(nextSep));
    stringLeft = stringLeft.slice(0, nextSep);
    separatorIdx = nextSep;
  }

  if (stringLeft) {
    slices.unshift(stringLeft);
  }
  return prefix + slices.join(" ");
}

export function amountToCurrencyPretty(amount: String, currency) {
  const amountStr = amountToCurrency(amount, currency);
  return prettyNumber(amountStr);
}

export function getAppCurrency() {
  return window.appSettings.default_currency;
}
